import { render, staticRenderFns } from "./OfertasComponent.vue?vue&type=template&id=249495da"
import script from "./OfertasComponent.vue?vue&type=script&lang=js"
export * from "./OfertasComponent.vue?vue&type=script&lang=js"
import style0 from "./OfertasComponent.vue?vue&type=style&index=0&id=249495da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports